import { logWarn } from './logger';

export interface RawHotspot {
  product_uuid: string;
  position_x: number;
  position_y: number;
  starts_at: number;
  duration: number;
  timing_units: string;
}

const isValidPercent = (value: unknown): boolean =>
  typeof value === 'number' && value >= 0 && value <= 100;

/**
 * Filters raw `custom_attributes.hotspots` entries, dropping (and logging) any that are
 * orphaned, out of the 0-100 position range, or have a non-positive duration.
 */
export const filterValidHotspots = (
  rawHotspots: unknown,
  productUuids: Set<string>,
): RawHotspot[] => {
  if (!Array.isArray(rawHotspots)) return [];

  return rawHotspots.filter((hotspot: RawHotspot) => {
    if (!productUuids.has(hotspot.product_uuid)) {
      logWarn(`Dropping hotspot: no matching product for product_uuid "${hotspot.product_uuid}"`);
      return false;
    }
    if (!isValidPercent(hotspot.position_x) || !isValidPercent(hotspot.position_y)) {
      logWarn(`Dropping hotspot for "${hotspot.product_uuid}": position out of 0-100 range`);
      return false;
    }
    if (typeof hotspot.duration !== 'number' || hotspot.duration <= 0) {
      logWarn(`Dropping hotspot for "${hotspot.product_uuid}": duration must be a positive number`);
      return false;
    }
    return true;
  });
};
